import type { Outline } from "../math/samplePath";

// Original, single closed contour: two pointed ears, seated body, curled tail.
// No pen lifts or decorative strokes: every visible contour point is reconstructed.
const segments: readonly (readonly [
  number,
  number,
  number,
  number,
  number,
  number,
])[] = [
  [-43, -141, -28, -139, -17, -136],
  [-7, -147, 6, -159, 13, -168],
  [20, -153, 24, -131, 25, -113],
  [41, -99, 45, -80, 39, -65],
  [35, -50, 25, -40, 15, -35],
  [21, -12, 44, 14, 49, 42],
  [58, 69, 54, 91, 41, 108],
  [72, 114, 99, 100, 100, 80],
  [101, 64, 89, 60, 80, 65],
  [70, 70, 62, 60, 68, 50],
  [85, 31, 122, 41, 126, 71],
  [133, 115, 94, 137, 50, 137],
  [13, 137, -27, 136, -61, 136],
  [-78, 136, -82, 125, -69, 118],
  [-64, 115, -57, 115, -53, 115],
  [-60, 91, -62, 56, -57, 26],
  [-54, 4, -51, -20, -55, -38],
  [-74, -43, -88, -55, -91, -73],
  [-96, -88, -89, -104, -80, -114],
  [-82, -135, -80, -156, -75, -169],
  [-62, -161, -51, -148, -43, -141],
];
const start = { x: -43, y: -141 };
export const cat: Outline = segments.map((s, i) => ({
  from: i === 0 ? start : { x: segments[i - 1][4], y: segments[i - 1][5] },
  c1: { x: s[0], y: s[1] },
  c2: { x: s[2], y: s[3] },
  to: { x: s[4], y: s[5] },
}));
